import dayjs from "dayjs";

export default async ({ queryKey }) => {
  const [key] = queryKey;
  const { access_token } = JSON.parse(
    localStorage.getItem("sb-qppuubklysscxghhqzsm-auth-token") || "{}"
  );
  const response = await fetch(
    "https://stats-api.prval.us/stats/global?" +
      new URLSearchParams({
        metric: key,
        from_date: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
        to_date: dayjs().add(1, "day").format("YYYY-MM-DD"),
      }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};
